import {
  legacy_createStore as createStore,
  combineReducers,
  applyMiddleware,
} from "redux";
import { thunk } from "redux-thunk";
// import UserListReducer from "./reducers/UserListReducer";
import RoleAndPermissionReducer from "./reducers/RolesAndPermissions/RolesAndPermissionsReducer";
import ChainIdReducer from "./reducers/ChainIdReducer";
import UpdateMasterHotelReducer from "./reducers/UpdateMasterHotelReducer/UpdateMasterHotelReducer";
import ViewTypeReducer from "./reducers/ViewTypeReducer";

export default function configureStore() {
  return createStore(
    combineReducers({
      // userListReducer: UserListReducer,
      permissionReducer: RoleAndPermissionReducer,
      chainIdReducer: ChainIdReducer,
      updateMasterHotelReducer: UpdateMasterHotelReducer,
      viewTypeReducer: ViewTypeReducer
    }),
    applyMiddleware(thunk)
  );
}
